import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {VoyagesAuditLazy} from "@containers/audit/continers/voyages/VoyagesAudit.lazy";

const VoyagesAuditPage = () => {
    return (
        <PageLayout
        >
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <VoyagesAuditLazy/>
            </Suspense>
        </PageLayout>
    )
};

export default VoyagesAuditPage;